import { Navigate } from "react-router-dom";
import { useCompany } from "../companies/CompanyContext";

// Nur in der Adminsicht (Super- und Subadmins) erreichbar.
export default function RequireAdminView({ children }) {
  const { userRole, loadingCompanies } = useCompany();

  if (loadingCompanies) {
    return null;
  }
  if (userRole !== "superadmin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
